module.exports = __webpack_public_path__ + "static/img/friend-head-bg.b4ad2ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/friend-head-bg.png
// module id = QWhA
// module chunks = 216